/**
 * Operator Create Modal
 * Popup form for creating an operator without leaving the list view
 */

import { useEffect, useState } from 'react'
import { operatorApi } from '../../services/operatorApi'
import OperatorForm from './OperatorForm'

export default function OperatorCreateModal({
  isOpen,
  onClose,
  onSuccess,
}) {
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset'
      setError(null)
      return undefined
    }

    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleSubmit = async (formData) => {
    setError(null)
    try {
      await operatorApi.createOperator(formData)
      onSuccess?.()
      onClose?.()
    } catch (err) {
      setError(err?.message || 'Failed to create operator')
      throw err
    }
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative bg-white rounded-xl shadow-xl max-w-lg w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-4 mb-5">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">Create New Operator</h2>
              <p className="text-xs text-gray-400 mt-0.5">Add a BillJean team member</p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1"
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}

          <OperatorForm
            key={isOpen ? 'create-open' : 'create-closed'}
            onSubmit={handleSubmit}
            onCancel={onClose}
            isEdit={false}
          />
        </div>
      </div>
    </div>
  )
}
